/* istanbul ignore file */
import * as _ from "lodash";
import { NormalizedSchema, schema } from "normalizr";

import { camelCaseDeep } from "@ctra/utils";

import cowSchemas from "../cows/schemas";
import { DairyCowEntity } from "../cows";
import { HerdGroupEntity } from "../herd-groups";

import { TrackerEntity, TrackerList, TrackerSource, TrackerResult, Effect } from "./typings";

/**
 * Here because its a custom implementation of a herd group that only comes from the ask ida QnA object
 */
const herdGroup = new schema.Entity(
  "herdGroup",
  {},
  {
    idAttribute: "HerdGroupID",
    processStrategy: ({ HerdGroupID, groupName, groupDescription }): HerdGroupEntity => ({
      id: HerdGroupID,
      name: groupName,
      description: groupDescription
    })
  }
);

const askIdaTracker = new schema.Entity(
  "QnA",
  {
    question: { herdGroup, cow: cowSchemas.dairyCow }
  },
  {
    idAttribute: "IdaQnAID",
    processStrategy: ({ IdaQnAID, active, farmID, question, answer }: TrackerSource): TrackerEntity => {
      const parsedQuestion = question ? JSON.parse(question) : {};
      const parsedAnswer = answer ? JSON.parse(answer) : {};

      /**
       * Rename "rumination" to "ruminating" for consistency
       */
      const effects = _.map(parsedQuestion?.effects, ({ effect, ...rest }) => ({
        effect: effect === "rumination" ? Effect.ruminating : effect,
        ...rest
      }));

      return {
        id: IdaQnAID,
        active,
        farm: farmID,
        question: {
          ...parsedQuestion,
          effects
        },
        answer: camelCaseDeep(parsedAnswer) as TrackerResult
      };
    }
  }
);

export type NormalizedQnAList = NormalizedSchema<
  { QnA: TrackerList; herdGroup: HerdGroupEntity; dairyCow: DairyCowEntity },
  Array<TrackerEntity["id"]>
>;

const askIdaTrackerList = new schema.Array(askIdaTracker);

export default {
  askIdaTrackerList,
  askIdaTracker
};
